import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const HomeIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10V11C2 11 2 11.43 2 12V12.99C2 13.99 2 15 2 15C2 15.55 2.45 16 3 16H6V11H10V16H13C13.55 16 14 15.55 14 15V10L8 4L2 10ZM15.71 7.29L14 5.59V2C14 1.45 13.55 1 13 1C12.45 1 12 1.45 12 2V3.59L8.71 0.29C8.53 0.11 8.28 0 8 0C7.72 0 7.47 0.11 7.29 0.29L0.29 7.29C0.11 7.47 0 7.72 0 8C0 8.55 0.45 9 1 9C1.28 9 1.53 8.89 1.71 8.71L8 2.41L14.29 8.7C14.47 8.89 14.72 9 15 9C15.55 9 16 8.55 16 8C16 7.72 15.89 7.47 15.71 7.29Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default HomeIcon;
